<template>
    <MediaWithTextBlock
        kind="image"
        :asset-id="content?.image"
        :content="{ title: content?.title, body: content?.body }"
        @enter="emit('enter')"
        @leave="emit('leave')"
    />
</template>

<script lang="ts" setup>
import MediaWithTextBlock from "~/components/view/MediaWithTextBlock.vue"

defineProps({
    content: {
        type: Object
    },
    properties: {
        type: Array as PropType<{translate: boolean, label: string}[]>
    }
})

const emit = defineEmits(['enter', 'leave'])
</script>
